import React, { useState, useCallback } from 'react';

import api from 'services/api';

import { TypeModalProps } from 'pages/Profile/types';

import { passwordRegex } from 'utils/regex';
import {
  ModalHeader,
  ModalTitleWrap,
  ModalTitle,
  ModallTitleText,
  ModalBody,
  ModalContent,
  FormComponent,
  Label,
  Input,
  Separator,
  ButtonsWrap,
  ButtonConfirm,
  ButtonCancel,
  ErrorMessage,
  WrapAlterSuccess,
  TextAlterSuccess,
} from './styles';

type ModalAlterPasswordProps = {
  cancelAlterPassword: () => void;
  setTypeModal: (typeModalParam: TypeModalProps) => void;
};

const ModalAlterPassword: React.FC<ModalAlterPasswordProps> = ({
  cancelAlterPassword,
  setTypeModal,
}) => {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordAgain, setPasswordAgain] = useState('');
  const [errorPasswordForce, setErrorPasswordForce] = useState<string[]>();
  const [errorPasswordAgain, setErrorPasswordAgain] = useState<string[]>();
  const [errorPassword, setErrorPassword] = useState<string[]>();
  const [passwordAlterSuccess, setPasswordAlterSuccess] = useState(false);
  const [hasErrorPassword, setHasErrorPassword] = useState(false);
  const [hasErrorPassordAgain, setHasErrorPasswordAgain] = useState(false);

  const handleAlterPassword = useCallback(async () => {
    setLoading(true);
    const userId = localStorage.getItem('@UltragazEmpresarial:userId');
    const access_token = localStorage.getItem(
      '@UltragazEmpresarial:accessToken'
    );

    const header = {
      'Content-Type': 'application/json',
      access_token,
    };

    const body = {
      password,
      newPassword,
      newPasswordConfirmation: passwordAgain,
    };

    try {
      const responseAlterPassword = await api.put(
        `industrial/customer/v1/users/${userId}/passwords`,
        body,
        {
          method: 'PUT',
          headers: header,
        }
      );
      if (responseAlterPassword.status === 204) {
        setPasswordAlterSuccess(true);
        setTypeModal('success');
        setLoading(false);
      }
    } catch (err: any) {
      setLoading(false);
      const messagesErrorPassword = [];
      const messagesNewPassword = [];
      const messagesPasswordConfirmation = [];
      let message = '';
      if (err.response.status === 401) {
        message = 'Senha incorreta';
        messagesErrorPassword.push(message);
        return setErrorPassword(messagesErrorPassword);
      }
      if (err.response.data.code === '401.003') {
        message = err.response.data.message;
        messagesErrorPassword.push(message);
        return setErrorPassword(messagesErrorPassword);
      }
      if (
        err.response.data.code === '422.052' ||
        err.response.data.code === '422.012'
      ) {
        message = err.response.data.message;
        messagesNewPassword.push(message);
        return setErrorPasswordForce(messagesNewPassword);
      }
      if (Array.isArray(err.response.data)) {
        const errResponse = err.response.data;
        errResponse.map((errResp: any) => {
          message = '';
          message = errResp.message.replace(
            'newPasswordConfirmation',
            'Confirmar nova senha'
          );
          message = message.replace('newPassword', 'nova senha');
          message = message.replace('password', 'senha');
          if (errResp.message.indexOf('newPassword ') !== -1) {
            messagesNewPassword.push(message);
          }
          if (errResp.message.indexOf('newPasswordConfirmation ') !== -1) {
            messagesPasswordConfirmation.push(message);
          }
          if (errResp.message.indexOf('password ') !== -1) {
            messagesErrorPassword.push(message);
          }
        });
      } else {
        let { message } = err.response.data;
        message = message.replace('password', 'senha');
        message = message.replace('newPassword', 'senha');
        message = message.replace(
          'newPasswordConfirmation',
          'Confirmar nova senha'
        );
        if (err.response.data.message.indexOf('newPassword ') !== -1) {
          messagesNewPassword.push(message);
        }
        if (
          err.response.data.message.indexOf('newPasswordConfirmation ') !== -1
        ) {
          messagesPasswordConfirmation.push(message);
        }
        if (err.response.data.message.indexOf('password ') !== -1) {
          messagesErrorPassword.push(message);
        }
      }

      if (messagesNewPassword.length > 0) {
        setErrorPasswordForce(messagesNewPassword);
      }
      if (messagesErrorPassword.length > 0) {
        setErrorPassword(messagesErrorPassword);
      }
      if (messagesPasswordConfirmation.length > 0) {
        setErrorPasswordAgain(messagesPasswordConfirmation);
      }
    }
  }, [password, newPassword, passwordAgain, setTypeModal]);

  const clearErrors = useCallback(() => {
    setErrorPassword([]);
    setErrorPasswordForce([]);
    setErrorPasswordAgain([]);
  }, []);

  const handlePassword = useCallback((e: any): void => {
    setHasErrorPassword(false);
    const newValue = e.target.value;
    setHasErrorPassword(!newValue.match(passwordRegex));
    setNewPassword(newValue);
  }, []);

  const handlePasswordAgain = useCallback(
    (e: any): void => {
      setHasErrorPasswordAgain(false);
      const newPassAgain = e.target.value;
      setHasErrorPasswordAgain(newPassword !== newPassAgain);
      setPasswordAgain(newPassAgain);
    },
    [newPassword]
  );

  return (
    <>
      {passwordAlterSuccess && (
        <>
          <ModalHeader closeButton />
          <ModalBody>
            <ModalContent>
              <WrapAlterSuccess>
                <TextAlterSuccess>Senha alterada com sucesso!</TextAlterSuccess>
                <ButtonConfirm
                  onClick={() => {
                    cancelAlterPassword();
                    setTypeModal('password');
                  }}
                >
                  OK
                </ButtonConfirm>
              </WrapAlterSuccess>
            </ModalContent>
          </ModalBody>
        </>
      )}
      {!passwordAlterSuccess && (
        <>
          <ModalHeader closeButton>
            <ModalTitleWrap>
              <ModalTitle>Alterar Senha</ModalTitle>
              <ModallTitleText>
                * Sua senha deverá conter o mínimo de 8 caracteres, pelo menos
                uma letra minúscula, uma letra maiúscula, um número e um
                símbolo. Não utilizar sua última senha cadastrada.
              </ModallTitleText>
            </ModalTitleWrap>
          </ModalHeader>
          <ModalBody>
            <ModalContent>
              <FormComponent>
                <Label forHtml="password">
                  Senha atual
                  <Input
                    onFocus={clearErrors}
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e: any) => setPassword(e.target.value)}
                    showChangeTextPassword="true"
                  />
                  {errorPassword &&
                    errorPassword.length > 0 &&
                    errorPassword.map((error) => (
                      <ErrorMessage>{error}</ErrorMessage>
                    ))}
                </Label>
                <Separator marginTop={27} marginBottom={15} />
                <Label forHtml="new-password">
                  Nova senha
                  <Input
                    onFocus={clearErrors}
                    type="password"
                    id="new-password"
                    value={newPassword}
                    onChange={handlePassword}
                    showChangeTextPassword="true"
                  />
                  <>
                    {errorPasswordForce &&
                      errorPasswordForce.length > 0 &&
                      errorPasswordForce.map((error) => (
                        <ErrorMessage>{error}</ErrorMessage>
                      ))}
                    {hasErrorPassword && (
                      <ErrorMessage>
                        Sua senha não atende aos critérios de senha.
                      </ErrorMessage>
                    )}
                  </>
                </Label>
                <Label forHtml="password-again">
                  Confirmar nova senha
                  <Input
                    onFocus={clearErrors}
                    type="password"
                    id="password-again"
                    value={passwordAgain}
                    onChange={handlePasswordAgain}
                    showChangeTextPassword="true"
                  />
                  <>
                    {errorPasswordAgain &&
                      errorPasswordAgain.length > 0 &&
                      errorPasswordAgain.map((error) => (
                        <ErrorMessage>{error}</ErrorMessage>
                      ))}
                    {hasErrorPassordAgain && (
                      <ErrorMessage>As senhas não coincidem.</ErrorMessage>
                    )}
                  </>
                </Label>
                <Separator marginTop={22} />
                <ButtonsWrap>
                  <ButtonCancel onClick={() => cancelAlterPassword()}>
                    Cancelar
                  </ButtonCancel>
                  <ButtonConfirm
                    loading={loading}
                    onClick={() => handleAlterPassword()}
                    disabled={
                      !password ||
                      !newPassword ||
                      !passwordAgain ||
                      hasErrorPassword ||
                      hasErrorPassordAgain
                    }
                  >
                    Alterar
                  </ButtonConfirm>
                </ButtonsWrap>
              </FormComponent>
            </ModalContent>
          </ModalBody>
        </>
      )}
    </>
  );
};

export default ModalAlterPassword;
